import styled from 'styled-components';

import hairBg from '../../assets/hair.svg';

import media from '../../styles/media.style';
import {
  BLACK,
  BG_GRAY,
  TEXT_GRAY,
  MOBILE_PADDING,
  SCREEN_LOCKUP_WIDTH,
  PAGE_WIDTH,
} from '../../styles/variables.style';

export const Section = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 20px ${MOBILE_PADDING}px;
  width: 100%;
  max-width: ${PAGE_WIDTH}px;
  margin: 20px auto;
  background-color: ${BG_GRAY.COMMON_1};
  background: center / cover no-repeat url(${hairBg}), ${BG_GRAY.COMMON_1};

  ${media.tabletL`
    margin: 40px auto;
    // padding: 40px 100px ${({ extended }) => (extended ? '36em' : '4em')};
    padding: 40px 100px 4em;
  `};
`;

export const SectionInner = styled.div`
  width: 100%;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  margin: 0 auto;
`;

export const Title = styled.h5`
  position: relative;
  text-transform: uppercase;
  margin: 0 0 60px;
  letter-spacing: 0.1em;
  text-align: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -18px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${BG_GRAY.COMMON_8};
    height: 3px;
    width: 40px;
  }

  ${media.tabletL`
    margin-top: 22px;
    margin-bottom: 100px;
  `};
`;

export const BenefitsContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  ${media.tabletL`
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
  `};
`;

export const BenefitsText = styled.div`
  width: 100%;
  max-width: 400px;

  ${media.tabletL`
    margin-right: 75px;
    width: 50%;
  `};

  div + div {
    margin-top: 50px;
  }
`;

export const ImageWrapper = styled.div`
  flex: 1;
  order: -1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 3em;

  ${media.tabletL`
    order: 0;
    margin-bottom: 0;
    max-width: 500px;
  `};
`;

export const BenefitTitle = styled.h3`
  font-size: 28px;
  line-height: 38px;
  margin: 0;
  text-transform: uppercase;
  color: ${TEXT_GRAY.COMMON_5};
`;

export const Text = styled.p`
  color: grey;
  margin: 2em 0 0 0;
  color: ${BLACK};

  ${media.tabletL`
    margin: 1em 0 0 0;
  `};

  h1,
  h2,
  h3,
  p {
    font-size: 16px;
    line-height: 1.5em;
    font-weight: 400;
    margin: 20px 0 0 0;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ProductBenefits/ProductBenefits.style.js